/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';

import { IRosreestrInfo, IRosreestrElement } from '../../../types/offerData';
import { trackInfoExpand } from '../tracking';

const COLLAPSED_MAX_ROWS = 3;

const getCollapsedElements = (elements: IRosreestrElement[]): IRosreestrElement[] => {
  return elements.slice(0, COLLAPSED_MAX_ROWS);
};

const isExpanded = (rosreestrInfo?: IRosreestrInfo | null): boolean => {
  if (!rosreestrInfo) {
    return true;
  }

  if (rosreestrInfo.cadastralMapPreview) {
    return rosreestrInfo.parts[0]?.elements.length <= COLLAPSED_MAX_ROWS && !rosreestrInfo.parts[1]?.elements.length;
  } else {
    return rosreestrInfo.parts.every(part => part.elements.length <= COLLAPSED_MAX_ROWS);
  }
};

export const useFormattedInfo = (rosreestrInfo?: IRosreestrInfo | null) => {
  const [expanded, setExpanded] = React.useState(isExpanded(rosreestrInfo));

  const handleInfoExpand = React.useCallback(() => {
    setExpanded(true);

    trackInfoExpand();
  }, [setExpanded]);

  return React.useMemo(() => {
    if (expanded) {
      return {
        formattedInfo: rosreestrInfo,
        onExpand: handleInfoExpand,
        showExpandButton: false,
      };
    }

    if (rosreestrInfo?.cadastralMapPreview) {
      return {
        formattedInfo: {
          ...rosreestrInfo,
          parts: [
            {
              ...rosreestrInfo!.parts[0],
              elements: getCollapsedElements(rosreestrInfo!.parts[0].elements),
            },
          ],
        } as IRosreestrInfo,
        onExpand: handleInfoExpand,
        showExpandButton: true,
      };
    }

    return {
      formattedInfo: {
        ...rosreestrInfo,
        parts: rosreestrInfo?.parts.map(part => ({
          ...part,
          elements: getCollapsedElements(part.elements),
        })),
      } as IRosreestrInfo,
      onExpand: handleInfoExpand,
      showExpandButton: true,
    };
  }, [expanded, handleInfoExpand, rosreestrInfo]);
};
